<div [class.readonly]="readonly$ | async">
  <div class="title">
    <h2>{{ props.label }}</h2>
  </div>

  @if ((productConfigurationFacade.isBreadcrumbShown() | async) && !isProductCategoryField) {
    <div class="product-breadcrumb" (click)="handleBreadcrumbClick()">
      <span>{{ (selectedItem?.product?.productCategory?.parent_id | attributeBaseData | async)?.label }}</span>
      <i class="far fa-chevron-right ps-2 pe-2"></i>
      <span>{{ (selectedItem?.product?.productCategory?.id | attributeBaseData | async)?.label }}</span>
    </div>
  }

  <div class="dental-accordion">
    @for (parent of items$.asObservable() | async; track parent; let index = $index) {
      <div class="product-selection">
        <div class="product-selection__header" (click)="openDropdown(index)">
          <span>{{ parent.label }}</span>
          <div>
            <i class="pi pi-fw pi-chevron-down" [class.pi-chevron-up]="activeAccordionIndex === index"></i>
          </div>
        </div>
        <div
          class="product-selection__body"
          [@detailExpand]="index === activeAccordionIndex ? 'expanded' : 'collapsed'">
          <div class="p-field-radiobutton">
            @for (child of parent.children; track child) {
              <div class="p-field-checkbox ps-1">
                <p-radioButton
                  [value]="child"
                  [inputId]="parent.value + child.value"
                  [(ngModel)]="selectedItem"
                  (onClick)="handleItemClick(child, index)">
                </p-radioButton>
                <label [for]="parent.value + child.value">
                  <span>{{ child.label }}</span>
                </label>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
